import React, { useState, useEffect } from "react";

import "./index.scss";
import axiosInstance from "../../../../services/api/API";
import CustomTable from "../../../../customComponents/CustomTable";
import { useNavigate } from "react-router-dom";
import viewIcon from "../../../../../Assets/icons/eye 1.svg";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import moment from "moment";
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import { IoMdClose } from "react-icons/io";

// Un-Checkbox.svg
const SupervisorList = () => {
  const [jobCardData, setJobCardData] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [servicesList, setServicesList] = useState([]);
  const [filterList, setFilterList] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalJobCardRecord,setTotalJobCardRecord] = useState({});

  const [ filterFormData, setFilterFormData ] = useState({})
  const [validationErrors, setValidationErrors] = useState({});
  const [ filters, setFilters ] = useState({})

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    fetchSeviceList();
  }, [filterList]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchSeviceList(newPage);
  };

  const onClickNavigetion = (item) => {
    return (
      <div onClick={() => handleEdit(item)}>
        <span> {item?.job_card_no}</span>
      </div>
    );
  };

  const fetchSeviceList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters
    try {
      const response = await axiosInstance.post(
        "/supervisertodo/supervisertodolist",
        {
          business_partner_id: 1,
          fromDate: allfilteredData?.fromDate?allfilteredData?.fromDate:"" ,
          toDate: allfilteredData?.toDate?allfilteredData?.toDate:"" ,
          orderBy: "job_card_id desc",
          page,
          pageSize,
          searchText:searchTerm,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        status: item?.solved == 0 ? "Pending" : "Done",
        job_card_no: onClickNavigetion(item),
        DeliveryDate:moment(item?.allocation_date).format("DD/MM/YYYY")
      }));
      setTotalRecords(response?.data?.data?.totalRecords);
      setServicesList(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
      setTotalJobCardRecord(response?.data?.data);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const handleEdit = (rowData) => {
    navigate("supervision-details", {
      state: { data: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const Job_Card_TABLE_HEADERS = [
    "Job No.",
    // "Business Partner ID",
    "Registration No.",
    "Customer Name",
    "Product Name",
    "Make",
    "Outstanding Amt.",
    "Delivery Date",
    "Status",

    "Action",
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Job No.": "job_card_no",
    // "Business Partner ID": "onboard_id",
    "Registration No.": "registration_no",
    "Customer Name": "customer_name",
    "Product Name": "product_name",
    "Make": "make_name",
    "Outstanding Amt.": "job_estimate_amount",
    "Delivery Date": "DeliveryDate",
    "Status": "status",

    Action: [
      // {
      //     type: "edit",
      //     icon: editIcon,
      //     label: "Edit"
      // },
      {
        type: "view",
        icon: viewIcon,
        label: "View",
      },
    ],
  };

  const onclickFilter = (data) => {
    setFilterList(data);
  };

  const clearSearch = () => {
    setFilterList();
  };

  useEffect(() => {
    fetchSeviceList()
  },[filters])
  
  const clearFilter = () => {
    setFilterFormData({})
    setFilters({});
    fetchSeviceList();
  };
  
  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),  
      required: true,
      gridClass: "col-lg-4",
    },
    {
        name: "endDate",
        label: "To Date",
        type: "date",
        maxDate: new Date(),
        required: true,
        gridClass: "col-lg-4",
    }
  ]
  
  const handleSearch = () => {
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
    });
  };

  const handleSearchInputChange=(event)=>{
    setSearchTerm(event?.target?.value);
  }
const heandelOnkeyDown=(event)=>{
  if(event?.key ==='Enter'){
    fetchSeviceList();
  }
}

const clearSearchAndFetch =()=>{
  setSearchTerm("")
}


  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div className="OnboardManagamentbuttonContainer col-md-4 mt-2 mb-2">
          <h5 style={{fontWeight:"600"}} >Supervisor To Do</h5>
        </div>
        <div className=" col-md-8 mt-2 mb-2 totalvaluescontainer ">
          <div className="topleftdataContainer">
            <div className="listTopDataValueText">{totalJobCardRecord?.total || 0}</div>
            <div>Total Job</div>
          </div>

          <div className="topleftdataContainer">
            <div className="listTopDataValueText">{totalJobCardRecord?.total_pending || 0}</div>
            <div>Pending Job</div>
          </div>
          <div
            // key={}
            className="topleftdataContainer"
          >
            <div className="listTopDataValueText">{totalJobCardRecord?.total_completed || 0}</div>
            <div>Completed Job</div>
          </div>
          <div
            // key={}
            className=""
          >
            <div className="listTopDataValueText">&#8377;{totalJobCardRecord?.total_revenue || 0}</div>
            <div>Revenue</div>
          </div>
        </div>
      </div>

      <div className="tableWrapper">
        <div className="filterView">
          <div className="filterLeftView col-md-4 pt-4 gap-2">
            <h5 style={{fontWeight:"600"}}>Supervisor To Do List</h5>
            <div className="searchinput-wrapper">
              <input
                type="text"
                className="searchinput"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchInputChange}
                onKeyDown={heandelOnkeyDown}
              />
                {searchTerm ? (
                <IoMdClose size={22} className="searchinput-close-icon" onClick={clearSearchAndFetch} />
              ) : (
                <img src={searchIcon} alt="Search" className="searchinput-icon" />
              )}
            </div>
          </div>
          <div className="filterRightView col-md-8 gap-2">
            <h5 style={{paddingTop:"30px"}} >Filter By</h5>
            {/* <ListFilters
              handleSearch={onclickFilter}
              clearSearch={clearSearch}
            /> */}
             <ListLogisticsFilters
      formConfig={PhysicalStockTakingInputs} 
      formData={filterFormData}
      setFormData={setFilterFormData}
      validationErrors={validationErrors}
      setValidationErrors={setValidationErrors}
      handleSearch={handleSearch}
      handleClear={clearFilter}
      // onSubmit={handleFormSubmit} 
      />
          </div>
        </div>
        <CustomTable
          data={servicesList}
          headers={Job_Card_TABLE_HEADERS}
          keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
          onEdit={handleEdit} // Pass the handleEdit function
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          handleViewButton={handleEdit}
          totalRecords={totalRecords}
        />
      </div>
    </div>
  );
};

export default SupervisorList;
